import { render, staticRenderFns } from "./MultiAddressTransfer.vue?vue&type=template&id=0c6e77c7&"
import script from "./MultiAddressTransfer.vue?vue&type=script&lang=js&"
export * from "./MultiAddressTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports